module.exports = __webpack_public_path__ + "static/img/jsmn.85fa90f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jsmn.png
// module id = jNlJ
// module chunks = 0